import { useMemo } from "react";

import numeral from "numeral";

import type { ColumnType } from "@similarweb/pro-logic-components";
import { ProgressBarWithValueCell } from "@similarweb/pro-logic-components";
import type { StrictColor } from "@similarweb/styles";
import { colorsPalettes, colorsSets } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import { NoDataCell } from "../../../components/NoDataCell";
import type { IGroupedDomainData } from "../../../hooks/useCommonColumnsConfig";

export interface IShareColumnData extends IGroupedDomainData {
    share?: number | null;
}

const colors = colorsSets.c.toArray() as StrictColor[];

export const useShareColumnConfig = () => {
    const translate = useTranslation();

    return useMemo(
        () =>
            ({
                title: translate("bt.report.channels.channel-traffic-share-table.share-column.title"),
                dataIndex: "share",
                minWidth: 180,
                render: (value, record, index) => {
                    if (value == null) {
                        return (
                            <Flex
                                flexGrow="1"
                                justifyContent="end"
                            >
                                <NoDataCell />
                            </Flex>
                        );
                    }

                    return (
                        <ProgressBarWithValueCell
                            share={value}
                            value={numeral(value).format("0.00%")}
                            color={Array.isArray(record.domain) ? colorsPalettes.carbon[100] : colors[index]}
                        />
                    );
                },
            }) satisfies ColumnType<IShareColumnData>,
        [translate],
    );
};
